import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { "data-cy": "conflict-notes-field" }
const _hoisted_2 = { class: "mt-1 flex flex-wrap items-baseline justify-between gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs font-medium text-error",
  "aria-live": "polite",
  "data-cy": "conflict-notes-over-limit"
}
const _hoisted_4 = {
  key: 1,
  class: "text-xs text-gray-500"
}

import { computed } from 'vue';
import LlTextarea from '@/components/LlTextarea.vue';
import { CONFLICT_NOTES_MAX_LENGTH } from '../constants/conflictRecordConstants';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictNotesField',
  props: {
    modelValue: {},
    id: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const count = computed(() => props.modelValue.length);
const overLimit = computed(() => count.value > CONFLICT_NOTES_MAX_LENGTH);
const countLabel = computed(() => count.value.toLocaleString('en-US'));
const limitLabel = CONFLICT_NOTES_MAX_LENGTH.toLocaleString('en-US');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LlTextarea, {
      id: __props.id,
      "model-value": __props.modelValue,
      label: "Notes",
      "label-class": "text-sm font-medium",
      rows: 4,
      disabled: __props.disabled,
      placeholder: "What you concluded: which results you cleared and why, and what you escalated.",
      "data-cy": "conflict-notes-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event ?? '')))
    }, null, 8, ["id", "model-value", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      (overLimit.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Notes are limited to " + _toDisplayString(_unref(limitLabel)) + " characters. You have " + _toDisplayString(countLabel.value) + ". ", 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, " One note for the whole check, in your own words. ")),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-auto text-xs tabular-nums", overLimit.value ? 'font-medium text-error' : 'text-gray-500']),
        "data-cy": "conflict-notes-count"
      }, _toDisplayString(countLabel.value) + " / " + _toDisplayString(_unref(limitLabel)), 3)
    ])
  ]))
}
}

})